export default __webpack_public_path__ + "imgs/education.b122915a224fb51bfa096624bb1a7de6.svg";